/* eslint-disable react/prop-types */

import { Box, Button, Card, Chip, Stack, Typography } from "@mui/material";
import InfoChip from "./InfoChip";
import { panelCardSx } from ".";
import NearMeRoundedIcon from "@mui/icons-material/NearMeRounded";
import MapRoundedIcon from "@mui/icons-material/MapRounded";
import MyLocationRoundedIcon from "@mui/icons-material/MyLocationRounded";
import NeshanReportMap from "./NeshanReportMap";
import { alpha } from "@mui/material/styles";

export default function MapPickerCard({ position, locationSource, onChange, onReport, loadingStats }) {
    return (
        <Card
            sx={{
                ...panelCardSx,
                p: { xs: 2.3, md: 3 },
                mb: 3,
                overflow: "hidden",
            }}
        >
            <Stack spacing={2}>
                <Stack
                    direction={{ xs: "column", md: "row" }}
                    alignItems={{ xs: "flex-start", md: "center" }}
                    justifyContent="space-between"
                    spacing={2}
                >
                    <Stack direction="row" spacing={1.2} alignItems="center">
                        <Box
                            sx={{
                                width: 42,
                                height: 42,
                                borderRadius: 2.5,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                bgcolor: alpha("#0284c7", 0.1),
                                color: "#0284c7",
                            }}
                        >
                            <MapRoundedIcon />
                        </Box>

                        <Box>
                            <Typography variant="h6" fontWeight={950} sx={{ color: "#0f172a" }}>
                                انتخاب موقعیت از روی نقشه
                            </Typography>

                            <Typography variant="body2" sx={{ color: "#64748b", fontWeight: 600 }}>
                                روی نقشه کلیک کنید تا مختصات همان نقطه برای گزارش استفاده شود.
                            </Typography>
                        </Box>
                    </Stack>

                    {position && (
                        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                            <InfoChip
                                icon={<MyLocationRoundedIcon />}
                                label={`Lat: ${Number(position.lat).toFixed(6)}`}
                            />
                            <InfoChip
                                icon={<NearMeRoundedIcon />}
                                label={`Long: ${Number(position.long).toFixed(6)}`}
                            />
                            <Chip
                                label={locationSource === "map" ? "منبع: نقشه" : "منبع: بیزینس"}
                                sx={{
                                    height: 34,
                                    borderRadius: 2.5,
                                    fontWeight: 900,
                                    color: locationSource === "map" ? "#0284c7" : "#15803d",
                                    bgcolor:
                                        locationSource === "map"
                                            ? alpha("#0284c7", 0.08)
                                            : alpha("#16a34a", 0.1),
                                }}
                            />
                        </Stack>
                    )}
                </Stack>

                <NeshanReportMap position={position} onChange={onChange} height={380} />

                <Stack
                    direction={{ xs: "column", md: "row" }}
                    spacing={1.2}
                    justifyContent="space-between"
                    alignItems={{ xs: "stretch", md: "center" }}
                >


                    <Button
                        variant="outlined"
                        disabled={!position || loadingStats}
                        onClick={onReport}
                        sx={{
                            borderRadius: 3,
                            fontWeight: 900,
                            color: "#0284c7",
                            borderColor: alpha("#0284c7", 0.45),
                            px: 2.5,
                            "&:hover": {
                                borderColor: "#0284c7",
                                bgcolor: alpha("#0284c7", 0.06),
                            },
                            "&.Mui-disabled": {
                                color: "#94a3b8",
                                borderColor: "rgba(148,163,184,0.35)",
                            },
                        }}
                    >
                        گزارش از روی نقشه
                    </Button>
                </Stack>
            </Stack>
        </Card>
    );
}